/** @file poseSource: the Pose block's badge: where the shown rotation comes from. */
import type { JointEdit } from './useJointEdit';

/** `rest (no key)` without a clip or key, `key` on a key here, `from key @ <frame>` inherited, `dragging` during a drag or scrub. */
export function poseSource(edit: JointEdit | null): string {
  const j = edit?.joint;
  if (j === undefined || j.source === 'rest') return 'rest (no key)';
  if (j.source === 'earlier') return `from key @ ${String(j.from)}`;
  return j.source === 'override' ? 'dragging' : 'key';
}
